import { createComponent } from '@carvana/merch-components';

export enum StatusTagEnum {
  Hold = 'hold',
  Locked = 'locked',
  Recent = 'recent',
  Reservable = 'reservable'
}

type StatusObj = Record<StatusTagEnum, string>;

export const tagTextMap: StatusObj = {
  hold: 'On Hold',
  locked: 'Purchase in Progress',
  recent: 'Recently Added',
  reservable: 'Pre-Order Now'
};

export const tagColorMap: StatusObj = {
  hold: 'bg-yellow-3 max-w-[61px]',
  locked: 'bg-red-2 max-w-[124px]',
  recent: 'bg-marketplace-purple max-w-[100px]',
  reservable: 'bg-blue-2 max-w-[97px]'
};

const TagWrapper = createComponent('div', {
  className:
    'flex h-20 w-full items-center overflow-hidden rounded-full px-8 text-xs font-bold leading-5 text-white'
});

type OwnProps = {
  status: StatusTagEnum | null;
};

export default function StatusTag({ status }: OwnProps) {
  return status ? (
    <TagWrapper className={tagColorMap[status]}>
      <p className="truncate">{tagTextMap[status]}</p>
    </TagWrapper>
  ) : null;
}
